




import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class IconTitle extends Vue {
  @Prop({ default: '' }) readonly type!: string

  // computed
  get className() {
    return [this.type].filter(e => !!e).join(' ')
  }
}
